<script setup lang="ts">
// -------------------------------
// 🔹 Imports Vue et composables
// -------------------------------
</script>

<template>
  <section class="px-4">
    <main class="mt-16 flex justify-center">
      <section
        class="flex w-full max-w-lg flex-col items-center justify-center gap-6 rounded-xl border border-gray-200 p-6 shadow-sm"
      >
        <!-- Grand SVG Not Found -->
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-40 w-40 text-gray-300"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M9.75 9.75l4.5 4.5M14.25 9.75l-4.5 4.5M12 3c4.97 0 9 4.03 9 9s-4.03 9-9 9-9-4.03-9-9 4.03-9 9-9z"
          />
        </svg>

        <!-- Texte principal -->
        <p class="text-center text-lg font-semibold text-gray-700">
          Aucun résultat trouvé
        </p>

        <!-- Phrase supplémentaire -->
        <p class="text-center text-sm text-gray-500">
          Vérifiez votre recherche ou essayez une autre requête.
        </p>
      </section>
    </main>
  </section>
</template>

<style scoped>
section {
  transition: all 0.3s ease-in-out;
}

/* Animation d'apparition douce */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

section > main > section {
  animation: fadeIn 0.4s ease-out;
}
</style>
